import { SIDEBAR_WIDTH, Spacing } from "@bonusx-global/bx-design-system";
import { HeaderV2LayoutAction } from "../../../../../legacy/components/HeaderV2/stores/header-v2-layout-store";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperGetVariant, IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

export class UpgradePageRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return true;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return true;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      contentLayoutStyles: {
        desktopOuterContainer: {
          padding: `${Spacing["2500"]} ${Spacing["2500"]} ${Spacing["4000"]} ${Spacing["2500"]} !important`,
        },
        desktop: {
          maxWidth: `96rem`,
          width: `calc(100vw - ${Spacing["5000"]} - ${SIDEBAR_WIDTH})`,
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return false;
  }

  getVariantHeaderSettings(_params?: IRouteWrapperGetVariant): IHeaderV2Store {
    return {
      layoutStore: {
        showLogoOnMobile: true,
        actions: [HeaderV2LayoutAction.notification, HeaderV2LayoutAction.search],
      },
    };
  }
}
